<template>
<div class="chapter">
<div class="inner_page">
<p class="C109"><em><a id="page_vii">Contents</a></em></p><a id="page_vii">
</a><p class="C117"><a id="page_vii"><em></em></a><em><a href="#/html/05_Acknowledgments#page_ix">Acknowledgments</a></em></p>
<p class="C117"><em><a href="#/html/06_Prologue#page_xi">Prologue</a></em></p>
<p class="C117"><a href="#/html/07_1__Toward_Embodied_Virtuality#page_1">1. Toward Embodied Virtuality</a></p>
<p class="C117"><a href="#/html/08_2__Virtual_Bodies_and_Flickering#page_25">2. Virtual Bodies and Flickering Signifiers</a></p>
<p class="C117"><span href="#/html/09_3__Contesting_for_the_Body_of_In#page_50" title="Link target outside of Sample">3. Contesting for the Body of Information: The Macy Conferences on Cybernetics</span></p>
<p class="C117"><span href="#/html/10_4__Liberal_Subjectivity_Imperile#page_84" title="Link target outside of Sample">4. Liberal Subjectivity Imperiled: Norbert Wiener and Cybernetic Anxiety</span></p>
<p class="C117"><span href="#/html/11_5__From_Hyphen_to_Splice__Cybern#page_113" title="Link target outside of Sample">5. From Hyphen to Splice: Cybernetic Syntax in <em>Limbo</em></span></p>
<p class="C117"><span href="#/html/12_6__The_Second_Wave_of_Cybernetic#page_131" title="Link target outside of Sample">6. The Second Wave of Cybernetics: From Reflexivity to Self-Organization</span></p>
<p class="C117"><span href="#/html/13_7__Turning_Reality_Inside_Out_an#page_160" title="Link target outside of Sample">7. Turning Reality Inside Out and Right Side Out: Boundary Work in the Mid-Sixties Novels of Philip K. Dick</span></p>
<p class="C117"><span href="#/html/14_8__The_Materiality_of_Informatic#page_192" title="Link target outside of Sample">8. The Materiality of Informatics</span></p>
<p class="C117"><span href="#/html/15_9__Narratives_of_Artificial_Life#page_222" title="Link target outside of Sample">9. Narratives of Artificial Life</span></p>
<p class="C117"><span href="#/html/16_10__The_Semiotics_of_Virtuality#page_247" title="Link target outside of Sample">10. The Semiotics of Virtuality: Mapping the Posthuman</span></p>
<p class="C118"><span href="#/html/17_11__Conclusion__What_Does_It_Mea#page_283" title="Link target outside of Sample">11. Conclusion: What Does It Mean to Be Posthuman?</span></p>
<p class="C117"><em><span href="#/html/18_Notes#page_293" title="Link target outside of Sample">Notes</span></em></p>
<p class="C117"><em><span href="#/html/19_Index#page_325" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?123a6735